import { Button, Card, ConfigProvider, Dropdown, FloatButton, Layout, Menu, MenuProps, Modal, theme } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import thTH from 'antd/locale/th_TH';
import R from '../img/LOGOVU.png'
import imgdata2 from '../img/IMG_7283.png'
import logo from '../img/VULOGO.png'
import { useState } from "react";
import {
    LogoutOutlined,
  } from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import Sider from "antd/es/layout/Sider";
import { signout } from "../FunctionForLater";

type MenuItem = Required<MenuProps>['items'][number];

const PressBar: React.FC = () =>{

    const location = useLocation();
    const [openMod,setopenMod] = useState(false)
    const navigate = useNavigate();
    
    const {
        token: { colorBgContainer, borderRadiusLG },
      } = theme.useToken();



      const items: MenuItem[] = [
      {
        key: '/main',
        label: <a onClick={()=>navigate(`/VU_HREC`)} target="_self" rel="noopener noreferrer"> หน้าหลัก</a> ,
      },{
        key: '/submain',
        label: <a onClick={()=>navigate(`/VU_HREC/RequestListView`)} target="_self" rel="noopener noreferrer"> ดูรายชื่อโครงการ</a> ,
      },{
        key: '/part1',
        label: 'ส่วนที่ 1 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์',
        children:[
          {
            key: '/part1.1',
            label: <a href = {'/VU_HREC/PresProjectInfo#part1-1'} target="_self" rel="noopener noreferrer">1.1 ข้อมูลเบื้องต้น</a>,
          },{
            key: '/part1.2',
            label: <a href = {'/VU_HREC/PresProjectInfo#part1-2'} target="_self" rel="noopener noreferrer">1.2 การพิจารณาจริยธรรม</a>,
          },{
            key: '/part1.3',
            label: <a href = {'/VU_HREC/PresProjectInfo#part1-3'} target="_self" rel="noopener noreferrer">1.3 ยา</a>,
          },{
            key: '/part1.4',
            label: <a href = {'/VU_HREC/PresProjectInfo#part1-4'} target="_self" rel="noopener noreferrer">1.4 ทรัพย์สินทางปัญญาและอื่น ๆ</a>,
          },{
            key: '/part1.5',
            label: <a href = {'/VU_HREC/PresProjectInfo#part1-5'} target="_self" rel="noopener noreferrer">1.5 คำรับรองจากผู้วิจัย</a>,
          }
      ]
      }
      ,{
        key: '/part2',
        label:  <a href={`/VU_HREC/PresProjectInfo#part2`} target="_self" rel="noopener noreferrer">ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย</a> ,
      },{
        key: '/part3',
        label:  <a href={`/VU_HREC/PresProjectInfo#part3`} target="_self" rel="noopener noreferrer">ส่วนที่ 3 แนบเอกสารหลักฐานเพิ่มเติม</a> ,
      }
    ]
    
    return(<>
    <ConfigProvider 
        locale={thTH}
        theme={{
          components: {
            Table: {
              bodySortBg:"",
              headerBg:"#8EA3A6",
              rowHoverBg:"#E6E9AF",
              footerBg:"#8EA3A6",
              headerColor:"white"
            },
            Menu: {
              fontFamily: 'kanit',
              itemBg: "#white",
              itemColor: "white",
              itemHoverColor: "#7F8CAA",
              itemSelectedBg: "#ffb6b5",
              itemSelectedColor: "#805b5b",
              subMenuItemSelectedColor:"#805b5b",
              popupBg:"black"
            },
            Layout: {
              siderBg: "#FFDBB5",
              headerBg: "#954C2E",

            },
            Input: {
              activeBg: 'white',
              hoverBg: 'white',
            },
            Select: {
              optionSelectedColor: '#8174A0',
              optionActiveBg: "#E5E1DA",
              controlItemBgActive: '#E5E1DA'
          },
          },
          token: {
            fontSize: 16,
            fontFamily: 'Kanit',
            colorBgBase: '#bfb6a8',
            colorBgContainer: 'white',
            colorBgElevated: 'white',
            colorBorder: "#179BAE",
          }
        }}
       >
        <link rel="icon" type="image/png" href={logo} />

         <Layout>
            <Header
                style={{
                    position: 'fixed',
                    top: 0,
                    width: '100%',
                    zIndex: 1001,
                    padding: '0 16px',
                    background: '#EFE4D2',
                    height: '64px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    transition: 'left 0.3s, width 0.3s',
                }}
                >
                {/* Left: Logo */}
                <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <a href="/VU_HREC" style={{ display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        <img
                        src={R}
                        alt="Logos"
                        style={{
                            objectFit: 'contain',
                            display: 'block',      // remove inline spacing
                        }}
                        />
                    </a>
                    <p style={{ color: '#954C2E', margin: 0, fontWeight:'bold' }}>
                    ระบบยื่นคำขอพิจารณาจริยธรรมวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล
                    </p>
                </div>

                {/* Right: User avatar + name + dropdown */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Dropdown
                    overlay={
                        <Menu>
                        <Menu.Item
                            key="logout"
                            icon={<LogoutOutlined />}
                            onClick={() => setopenMod(true)}
                        >
                            ออกจากระบบ
                        </Menu.Item>
                        </Menu>
                    }
                    trigger={['click']}
                    >
                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        <img
                        src={sessionStorage.getItem('user_picture') || imgdata2}
                        alt="User"
                        style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                        }}
                        />
                        <p style={{ color: '#954C2E', margin: 0, marginLeft: '8px' }}>
                        {sessionStorage.getItem('fullname')}
                        </p>
                    </div>
                    </Dropdown>
                </div>
            </Header>
            <Layout style={{height:'100vh'}}>
            {location.pathname== '/VU_HREC/PresProjectInfo'
      &&
      <AnimatePresence>
        <motion.div
          key="bloodCard"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          >
          <Sider
            width={'15vw'}
            style={{
              marginTop: '64px', 
              right: 0, 
              height: 'calc(100vh - 64px)',
              overflow: 'clip',
              background: 'transparent',
              borderRight: '1px solid white',
              top: 0,
              bottom: 0,
              scrollbarWidth: 'thin',
            }}
          >
              <Menu
                style={{ width: '15vw',padding: 10  }}
                mode="inline"
                items={items}
              />
            </Sider>
          </motion.div>
        </AnimatePresence>}
        <Content
          style={{
              margin: '25px 70px',
              padding: 24,
              minHeight: '50vh', 
              height:'80vh',
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              marginTop: '80px',
              display: 'flex',      
              flexDirection: 'column', 
              overflowY: 'auto',  
          }}
          >
        {(location.pathname=='/VU_HREC/CommitteeManagement'||location.pathname=='/VU_HREC/RequestListView')&&<Button onClick={()=>window.location.href = "/VU_HREC/"} style={{width:50}}>กลับ</Button>}
        {(location.pathname=='/VU_HREC/PresProjectInfo')&&<Button onClick={()=>window.location.href = "/VU_HREC/RequestListView"} style={{width:50}}>กลับ</Button>}
          
          <Card
              style={{
              height: '80vh',       
              overflowY: 'auto',    
              borderRadius: borderRadiusLG,
              border:'none',
              scrollBehavior: 'smooth',
              }}
          >
          <Outlet/>
          <FloatButton.BackTop />
              <Modal
                title="ยืนยันการออกจากระบบ"
                open={openMod}
                onCancel={()=>setopenMod(false)}
                footer={[
                    <><Button key="back" onClick={()=>setopenMod(false)}>
                        กลับ
                    </Button><Button type='primary' danger onClick={() => signout()}>
                        ใช่
                    </Button></>
                ]}
          >
          คุณต้องการออกจากระบบใช่หรือไม่
              </Modal>
          </Card>
        </Content>
        
        </Layout>
         </Layout>
       </ConfigProvider>
    </>)
}
export default PressBar;